// Mock data for Amazon Product Type search & sync

export const amazonProductTypes: Record<string, any>[] = [
  { name: "ABRASIVES", displayName: "Abrasive", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "ABRASIVE_BELTS", displayName: "Abrasive Belt", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "ABRASIVE_BRUSH", displayName: "Abrasive Brush", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "ABRASIVE_SHEETS", displayName: "Abrasive Sheet", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "ABRASIVE_WHEELS", displayName: "Abrasive Wheel", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BICYCLE_BRAKE_PAD", displayName: "Bicycle Brake Pad", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRA", displayName: "Bra", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRACELET", displayName: "Bracelet", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRAKE_KIT", displayName: "Brake Kit", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRAKE_ROTOR", displayName: "Brake Rotor", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRASS_AND_WOODWIND_INSTRUMENTS", displayName: "Wind Instrument", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "BRA_UNDERWEAR_SET", displayName: "Bra & Underwear Set", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "FASHIONNECKLACEBRACELETANKLET", displayName: "FASHIONNECKLACEBRACELETANKLET", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "FINENECKLACEBRACELETANKLET", displayName: "FINENECKLACEBRACELETANKLET", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "MOUNT_BRACKET", displayName: "Mount & Bracket", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "ORTHOPEDIC_BRACE", displayName: "Orthopedic Brace", marketplaceIds: ["A21TJRUUN4KGV"] },
  { name: "VEHICLE_BRAKE_PAD", displayName: "Vehicle Brake Pad", marketplaceIds: ["A21TJRUUN4KGV"] },
];

export const syncTargets: Record<string, any>[] = [
  { id: 'flipkart', name: 'Flipkart', logo: '\uD83D\uDECD\uFE0F' },
  { id: 'wish', name: 'Wish', logo: '\u2B50' },
  { id: 'meesho', name: 'Meesho', logo: '\uD83D\uDCE6' },
];

export const syncScopeOptions: Record<string, any>[] = [
  { id: 'import_products', label: 'Import products', defaultChecked: true },
  { id: 'normalize_attributes', label: 'Normalize attributes', defaultChecked: true },
  { id: 'generate_mappings', label: 'Generate mappings', defaultChecked: true },
  { id: 'sync_inventory', label: 'Sync inventory', defaultChecked: false },
];

export const productTypeSyncSteps: Record<string, any>[] = [
  { id: 1, name: 'Fetch taxonomy', status: 'pending' },
  { id: 2, name: 'Import matching products', status: 'pending' },
  { id: 3, name: 'Normalize attributes', status: 'pending' },
  { id: 4, name: 'Generate mappings', status: 'pending' },
  { id: 5, name: 'Finalize', status: 'pending' },
];

export const productTypeSyncLogs: Record<string, any>[] = [
  { id: 1, timestamp: '2026-01-09T15:00:01Z', level: 'info', message: 'Initiating product type sync for BRA...' },
  { id: 2, timestamp: '2026-01-09T15:00:03Z', level: 'info', message: 'Fetching taxonomy for A21TJRUUN4KGV...' },
  { id: 3, timestamp: '2026-01-09T15:00:08Z', level: 'success', message: 'Taxonomy fetched — 1 product type matched' },
  { id: 4, timestamp: '2026-01-09T15:00:12Z', level: 'info', message: 'Importing 342 matching products...' },
  { id: 5, timestamp: '2026-01-09T15:00:20Z', level: 'warning', message: '4 products missing required attributes' },
];
